module.exports = __webpack_public_path__ + "img/北京办公室4.879db8f7.jpg";